<template>
    <div class="buyRiskDialog-container">
        <el-dialog
            :title="title"
            :visible.sync="computedVisible"
            :close-on-click-modal="false"
            :close-on-press-escape="false"
            width="550px"
        >
            <!-- 文案区域 -->
            <div class="dialog-content">
                <div v-if="type === 'warn'" class="contentTitle">
                    根据相关法律法规要求，请在投资前认真阅读以下内容：
                </div>
                <div class="content">&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;{{ content }}</div>
            </div>
            <!-- 按钮区域（slot footer） -->
            <div slot="footer" class="dialog-footer">
                <el-button type="primary" v-on:click="handleConfirm">
                    {{ buttonText }}
                </el-button>
            </div>
        </el-dialog>
    </div>
</template>

<script>
export default {
    name: "BuyRiskDialog",
    props: {
        // 是否显示弹窗（.sync修饰符实现双向绑定）
        visible: {
            type: Boolean,
            default: false
        },
        // 弹窗类型：forbid（限制购买）/ warn（风险提示）
        // eslint-disable-next-line vue/require-default-prop
        type: {
            type: String,
            required: false
        },
        // 提示文案（父组件传递，避免子组件硬编码）
        content: {
            type: String,
            required: true
        },
        // 按钮文案（父组件传递，适配不同场景）
        buttonText: {
            type: String,
            required: true
        }
    },
    computed: {
        // 根据类型动态生成标题
        title() {
            return this.type === "forbid" ? "高龄客户风险提示" : "高龄客户风险提示";
        },
        computedVisible: {
            get() {
                return this.visible; // 从prop获取值
            },
            set(value) {
                this.$emit("update:visible", value); // 通知父组件更新
            }
        }
    },
    methods: {
        // 处理按钮点击事件（触发父组件回调）
        handleConfirm() {
            this.$emit("confirm"); // 发射确认事件，父组件处理后续逻辑
            // this.$emit("update:visible", false); // 关闭弹窗（.sync修饰符）
            this.computedVisible = false;
        }
    }
};
</script>

<style scoped lang="scss">
.dialog-content {
    font-size: 15px;
    .contentTitle {
        color: #333;
        font-weight: 600;
        margin-bottom: 10px;
    }
    .content {
        color: #606266;
        line-height: 22px;
    }
}
.buyRiskDialog-container {
    :deep(.el-dialog__header) {
        padding-bottom: 15px;
        background: #f1f1f1;
        font-size: 18px;
        color: #424242;
        .el-dialog__close {
            color: #424242;
        }
    }
    :deep(.el-dialog__body) {
        padding: 15px 38px;
    }
    :deep(.dialog-footer) {
        text-align: center;
        padding-top: 0;
    }
}
/* 限制购买按钮样式（区分风险提示按钮） */
.forbid-btn {
    background-color: #909399;
    border-color: #909399;
    color: #fff;
}
.forbid-btn:hover {
    background-color: #797b7e;
    border-color: #797b7e;
}
</style>
